import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { composeWithDevTools } from "redux-devtools-extension";
import rootReducers from "./reducers/rootReducer";
const persistConfig = {
  key: "ERP-Kalasan",
  storage,
  whitelist: ["user", "interface"],
  // whitelist: ["user", "interface", "receive"], //kalo mau nyalain ini install localforage terus storagenya diganti ke localforage biar persist ngga simpen ke localStorage
};

const persistedReducer = persistReducer(persistConfig, rootReducers);
export const store = createStore(
  persistedReducer,
  composeWithDevTools(applyMiddleware(thunk)),
);
export const persistor = persistStore(store);
